import type { ShinkansenSeatType, ShinkansenTicketType } from '../traveler_information';

export const DEFAULT_SHINKANSEN_TICKET_TYPE: ShinkansenTicketType = 'normal';
export const DEFAULT_SHINKANSEN_SEAT_TYPE: ShinkansenSeatType = 'free';

// TransportElement.railwayTicketType の数値は app/models/railway_ticket_type.rb の定数と対応する
export const convertNumberToShinkansenTicketType = (
  railwayTicketType: number | null | undefined
): ShinkansenTicketType | undefined => {
  switch (railwayTicketType) {
    case 0:
      return 'normal';
    case 1:
      return 'kyuusyuu';
    case 2:
      return 'bulk_ticket';
    case 3:
      return 'ex';
    case 4:
      return 'business_ekinet';
    default:
      return undefined;
  }
};

// TransportElement.railwaySeatType の数値は app/models/railway_seat_type.rb の定数と対応する
export const convertNumberToShinkansenSeatType = (
  railwaySeatType: number | null | undefined
): ShinkansenSeatType | undefined => {
  switch (railwaySeatType) {
    case 0:
      return 'free';
    case 1:
      return 'reserve';
    case 2:
      return 'green';
    case 3:
      return 'bulk_ticket';
    case 4:
      return 'ex';
    case 5:
      return 'gran_class';
    default:
      return undefined;
  }
};

export const resolveShinkansenTicketType = (
  travelerTicketType: ShinkansenTicketType | null | undefined,
  railwayTicketType: number | null | undefined
): ShinkansenTicketType =>
  travelerTicketType || convertNumberToShinkansenTicketType(railwayTicketType) || DEFAULT_SHINKANSEN_TICKET_TYPE;

export const resolveShinkansenSeatType = (
  travelerSeatType: ShinkansenSeatType | null | undefined,
  railwaySeatType: number | null | undefined
): ShinkansenSeatType =>
  travelerSeatType || convertNumberToShinkansenSeatType(railwaySeatType) || DEFAULT_SHINKANSEN_SEAT_TYPE;
